import { NgModule } from 'ng-metadata/core';
import {PrmServiceNoOfferFound} from './noOfferFound/noOfferFound.directive';
import {PrmServicePhysicalBestOffer} from './physicalBestOffer/physicalBestOffer.directive';
import {PrmServiceNgrs} from './ngrs.directive';
import {PhysicalBestOfferService} from './physicalBestOffer/physicalBestOffer.service';
import {NgrsService} from './ngrs.service';
import {PrmGetItRequest} from './getItRequest/getItRequest.directive';
import {GetItRequestService} from './getItRequest/getItRequest.service'
import {FormBuilderService} from '../../../infra/formBuilder/formBuilder.service';
import {PrmNgrsBriefResultLine} from './ngrsBriefResultLine/ngrsBriefResultLine.directive';
import {PrmNgrsResultsButton} from './resultsButton/ngrsResultsButton.directive';
import {PrmBriefResultDeliveryOptionLink} from './ngrsBriefResultLine/briefResultDeliveryOptionLink/briefResultDeliveryOptionLink.directive';
import {PrmBackToLibrarySearchButton} from './backToLibrarySearchButton/backToLibrarySearchButton.directive';
import {PrmBriefResultPhysicalBestOffer} from './ngrsBriefResultLine/briefResultPhysicalBestOffer/briefResultPhysicalBestOffer.directive';
import {PrmPhysicalDeliveryOptions} from './physicalDeliveryOptions/physicalDeliveryOptions.directive';
import {PrmPhysicalDeliveryOptionsTable} from './physicalDeliveryOptionsTable/physicalDeliveryOptionsTable.directive';
import {PrmBriefResultDigitalBestOffer} from './ngrsBriefResultLine/briefResultDigitalBestOffer/briefResultDigitalBestOffer.directive';
import {PrmSliderField} from './sliderField/sliderField.directive';
import {PrmLibrariesAroundBar} from './librariesAroundBar/librariesAroundBar.directive';
import {GtiService} from './gti.service';
import {PrmProgressBar} from './progressBar/progressBar.directive';
import {ProgressBarService} from './progressBar/progressBar.service';
import {PrmProgressCheckBox} from './progressBar/progressCheckBox/progressCheckBox.directive';
import {ProgressCheckBoxService} from './progressBar/progressCheckBox/progressCheckBox.service';
import {PrmPhysicalDeliveryMoreOptionRow} from "./physicalDeliveryMoreOptionRow/physicalDeliveryMoreOptionRow.directive";
import {PhysicalDeliveryMoreOptionRowService} from "./physicalDeliveryMoreOptionRow/physicalDeliveryMoreOptionRow.service";
import {PrmMultiSelectFilter } from './multiSelectFilter/multiSelectFilter.directive';
import {PrmOfferDetailsTile} from './getItRequest/offerDetailsTile/offerDetailsTile.directive'
import { PrmRapidoMessageBar } from './rapidoMessageBar/rapidoMessageBar.directive';
import { PrmRapidoNoOfferMessage } from './rapidoNoOfferMessage/rapidoNoOfferMessage.directive';
import { PickupAnywhereForm } from './pickup-anywhere-form/pickupAnywhereForm.directive';
import { PickupAnywhereService } from './pickup-anywhere-form/pickupAnywhereForm.service';


@NgModule({
    declarations: [
        PrmServicePhysicalBestOffer ,
        PrmServiceNoOfferFound,
        PrmServiceNgrs,
        PrmGetItRequest,       
        PrmServiceNgrs,
        PrmBackToLibrarySearchButton,
        PrmNgrsResultsButton,
        PrmNgrsBriefResultLine,
        PrmBriefResultDeliveryOptionLink,
        PrmBriefResultPhysicalBestOffer,
        PrmPhysicalDeliveryOptions,
        PrmPhysicalDeliveryOptionsTable,
        PrmSliderField,
        PrmLibrariesAroundBar,
        PrmBriefResultPhysicalBestOffer,
        PrmBriefResultDigitalBestOffer,
        PrmProgressBar,
        PrmProgressCheckBox,
        PrmPhysicalDeliveryMoreOptionRow,
        PrmMultiSelectFilter,
        PrmOfferDetailsTile,
        PrmRapidoMessageBar,
        PrmRapidoNoOfferMessage,
        PickupAnywhereForm
    ],
    providers: [
        PhysicalBestOfferService,
        NgrsService,
        GetItRequestService,
        FormBuilderService,
        GtiService,
        ProgressBarService,
        ProgressCheckBoxService,
        PhysicalDeliveryMoreOptionRowService,
        PickupAnywhereService
    ],
    imports:[
        
    ]
})
export class NgrsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrs.module.ts